<template>
  <BaseItem
      ref="RefItem"
      :item-uid="itemUid"
      parentComponent="UserTable"
      :lock-page="lockPage"
      :dto-detail-model="dto_detail_model"
      :dto-save-model="dto_save_model"
      :dto_validate_model="dto_validate_model"
      :store-name="store_name"
      :modal-dialog="modalDialog"
      :routeFullScreen="routeFullScreen"
      :height="height"
      :width="width"
  >
    <template v-slot:body="{editedItem, editedItemCommon, slotHeight}">
      <v-row class="px-3">
        <v-col cols="4">
          <v-text-field
              v-model="editedItem.username"
              :label="$t('columns.username')"
              outlined
              dense
              class="mb-n6"
              counter="50"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row class="px-3">
        <v-col cols="4">
          <v-text-field
              v-model="editedItem.shortname"
              :label="$t('columns.shortname')"
              outlined
              dense
              class="mb-n6"
              counter="50"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row class="px-3">
        <v-col cols="4">
          <v-text-field
              v-model="editedItem.first_name"
              :label="$t('columns.first_name')"
              outlined
              dense
              class="mb-n6"
              counter="50"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row class="px-3">
        <v-col cols="4">
          <v-text-field
              v-model="editedItem.last_name"
              :label="$t('columns.last_name')"
              outlined
              dense
              class="mb-n6"
              counter="50"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row class="px-3">
        <v-col cols="4">
          <v-text-field
              v-model="editedItem.email"
              :label="$t('columns.email')"
              outlined
              dense
              counter="50"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row class="px-3">
        <v-col cols="2">
          <v-checkbox
              v-model="editedItem.is_staff"
              :label="$t('columns.is_staff')"
              outlined
              dense
          >
          </v-checkbox>
        </v-col>
        <v-col cols="2">
          <v-checkbox
              v-model="editedItem.is_superuser"
              :label="$t('columns.is_superuser')"
              outlined
              dense
          >
          </v-checkbox>
        </v-col>
      </v-row>
      <v-row class="px-3">
        <v-col cols="4">
          <v-autocomplete
              v-model="editedItem.human_user"
              item-text="user"
              :label="$t('columns.human_user')"
              outlined
              :items="editedItemCommon.human_users"
              dense
              :return-object="true"
          >
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="px-3">
        <v-col cols="4">
          <v-select
              v-model="editedItem.groups"
              item-text="name"
              :label="$t('columns.groups')"
              outlined
              :items="editedItemCommon.groups"
              small-chips
              dense
              multiple
              :return-object="true"
          ></v-select>
        </v-col>
      </v-row>
      <v-row class="px-3">
        <v-col cols="4">
          <v-text-field
              v-model="editedItem.account_password"
              :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show_password ? 'text' : 'password'"
              :label="$t('columns.account_password')"
              hint="At least 8 characters"
              outlined
              dense
              counter
              @input="editedItem.account_password = $event !== '' ? $event : null"
              @click:append="show_password = !show_password"
              :error="editedItem.property_state.account_password.error"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="px-3">
        <v-col cols="4">
          <v-text-field
              v-model="editedItem.confirm_password"
              :append-icon="show_confirm_password ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show_confirm_password ? 'text' : 'password'"
              :label="$t('columns.confirm_password')"
              hint="At least 8 characters"
              outlined
              dense
              counter
              @input="editedItem.confirm_password = $event !== '' ? $event : null"
              @click:append="show_confirm_password = !show_confirm_password"
              :error="editedItem.property_state.confirm_password.error"
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
  </BaseItem>
</template>

<script>
import ConfirmDialog from "@/components/Base/ConfirmDialog";
// import commonFunction from "@/commonFunction/commonFunction"
import BaseItem from "@/components/Base/BaseItem";
import {v4 as uuidv4} from "uuid";
import fileFunction from "@/commonFunction/fileFunction";
import TipTapEditor from "@/components/TipTap/TipTapEditor";
import BaseDeleteIcon from "@/components/Base/BaseDeleteIcon";


export default {
  name: 'UserItem',
  props: {
    itemUid: {default: null},
    dto_detail_model: {type: [String], default: 'UserDetailQueryDTO'},
    dto_save_model: {type: [String], default: 'UserSaveCommandDTO'},
    dto_validate_model: {type: [String], default: 'UserValidateCommandDTO'},
    store_name: {type: [String], default: 'UserTable'},
    modalDialog: {type: [Boolean], default: false},
    routeFullScreen: {type: [Object], default: null},
    height: {default: null},
    width: {default: null},
  },

  components: {
    BaseDeleteIcon,
    ConfirmDialog,
    BaseItem,
  },

  computed: {},

  methods: {
    onClose(event) {
      console.log('unload', event);
      if (this.$refs.RefItem.countBackup > 0) {
        event.returnValue = 'Do you really want to leave? you have unsaved changes!'
        return event.returnValue
      }
      return true
    },
    lockPage(editedItem) {
      return !(!!editedItem && !!editedItem.page_properties && !editedItem.page_properties.lock_page)
    },
  },

  async mounted() {
    window.addEventListener('beforeunload', this.onClose)
  }
  ,

  beforeRouteLeave(to, from, next) {
    console.log('beforeRouteLeave')
    if (this.$refs.RefItem.countBackup === 0)
      next()
    else {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer)
        next()
      else
        next(false)
    }
  },

  data() {
    return {
      file: null,
      show_password: false,
      show_confirm_password: false,
    }
  }
}
</script>

<style>
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>

<i18n>
{
  "en": {
    "columns": {
      "deleted": " ",
      "edit": " ",
      "id": "ID",
      "username": "Username",
      "first_name": "First name",
      "last_name": "Last name",
      "email": "Email",
      "is_staff": "Is staff",
      "is_active": "Is active",
      "is_superuser": "Is superuser",
      "last_login": "Last logon",
      "date_join": "Date join",
      "account_password": "Account password",
      "confirm_password": "Confirm password"
    }
  },
  "de": {
    "columns": {
      "deleted": " ",
      "edit": " ",
      "id": "ID",
      "username": "Username",
      "first_name": "First name",
      "last_name": "Last name",
      "email": "Email",
      "is_staff": "Is staff",
      "is_active": "Is active",
      "is_superuser": "Is superuser",
      "last_login": "Last logon",
      "date_join": "Date join",
      "account_password": "Account password",
      "confirm_password": "Confirm password"
    }
  }
}
</i18n>
